import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { collection, addDoc } from "firebase/firestore";
import { db } from "../../firebase";
import { QRCodeCanvas } from "qrcode.react";
import { Box, Button, TextField, MenuItem, Typography, Paper } from "@mui/material";

function DehydrationForm() {
  const [formData, setFormData] = useState({
    idNumber: "",
    dehydrationStartDate: "",
    dehydrationTemperature: "",
    dehydrationTimeInterval: "",
    dehydrationEndDate: "",
    totalDehydrationTime: "",
    dryWeightG: "",
    dryWeightLbs: "",
    grindingDate: "",
    grindingTotalTime: "",
    powderWeightG: "",
    powderWeightLbs: "",
  });

  const [submittedData, setSubmittedData] = useState(null);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
      ...(name === "dryWeightG" && { dryWeightLbs: (value * 0.00220462).toFixed(2) }),
      ...(name === "dryWeightLbs" && { dryWeightG: (value / 0.00220462).toFixed(2) }),
      ...(name === "powderWeightG" && { powderWeightLbs: (value * 0.00220462).toFixed(2) }),
      ...(name === "powderWeightLbs" && { powderWeightG: (value / 0.00220462).toFixed(2) }),
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const newEntry = {
        "ID Number": formData.idNumber,
        "Dehydration Start Date": formData.dehydrationStartDate,
        "Dehydration Temperature": formData.dehydrationTemperature,
        "Dehydration Time Interval": formData.dehydrationTimeInterval,
        "Dehydration End Date": formData.dehydrationEndDate,
        "Total Dehydration Time (hours)": formData.totalDehydrationTime,
        "Dry Weight (g)": formData.dryWeightG,
        "Dry Weight (lbs)": formData.dryWeightLbs,
        "Grinding Date": formData.grindingDate,
        "Grinding Total Time (mins)": formData.grindingTotalTime,
        "Powder Weight (g)": formData.powderWeightG,
        "Powder Weight (lbs)": formData.powderWeightLbs,
        qrCodeValue: formData.idNumber,
      };

      await addDoc(collection(db, "shipments"), newEntry);
      setSubmittedData(newEntry);
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const handlePrint = () => {
    window.print();
  };

  if (submittedData) {
    return (
      <Box sx={{ textAlign: "center", mt: 4 }}>
        <Typography variant="h5" sx={{ color: "#d9d9d9", mb: 2 }}>
          QR Code & ID Number
        </Typography>
        <Paper sx={{ p: 4, display: "inline-block", textAlign: "center" }}>
          <QRCodeCanvas value={submittedData.qrCodeValue} size={150} />
          <Typography variant="h6" sx={{ mt: 2 }}>
            {submittedData["ID Number"]}
          </Typography>
          <Button variant="contained" sx={{ mt: 2 }} onClick={handlePrint}>
            Print
          </Button>
        </Paper>
      </Box>
    );
  }

  return (
    <Box sx={{ maxWidth: 500, mx: "auto", mt: 4 }}>
      <Typography variant="h7" sx={{ color: "#d9d9d9", textAlign: "center" }}>
        Dehydration & Grinding Form
      </Typography>
      <Typography component="p" sx={{ color: "#d9d9d9", textAlign: "center", cursor: "pointer" }} onClick={() => navigate("/shipments/new")}>
        ← Back to Form Selection
      </Typography>
      <Paper sx={{ p: 3, mt: 2 }}>
        <form onSubmit={handleSubmit}>
          <TextField fullWidth type="date" label="Dehydration Start Date" name="dehydrationStartDate" value={formData.dehydrationStartDate} onChange={handleChange} sx={{ mb: 2 }} required />
          <TextField fullWidth label="Dehydration Temperature" name="dehydrationTemperature" value={formData.dehydrationTemperature} onChange={handleChange} sx={{ mb: 2 }} required />
          <TextField select fullWidth label="Dehydration Time Interval" name="dehydrationTimeInterval" value={formData.dehydrationTimeInterval} onChange={handleChange} sx={{ mb: 2 }} required>
            {["24 hr", "30 hr", "34 hr", "40 hr", "44 hr"].map((time, index) => (
              <MenuItem key={index} value={time}>{time}</MenuItem>
            ))}
          </TextField>
          <TextField fullWidth type="date" label="Dehydration End Date" name="dehydrationEndDate" value={formData.dehydrationEndDate} onChange={handleChange} sx={{ mb: 2 }} required />
          <TextField fullWidth label="Total Dehydration Time (hours)" name="totalDehydrationTime" value={formData.totalDehydrationTime} onChange={handleChange} sx={{ mb: 2 }} required />
          <TextField fullWidth label="Dry Weight (g)" name="dryWeightG" value={formData.dryWeightG} onChange={handleChange} sx={{ mb: 2 }} required />
          <TextField fullWidth label="Dry Weight (lbs)" name="dryWeightLbs" value={formData.dryWeightLbs} onChange={handleChange} sx={{ mb: 2 }} required />
          <TextField fullWidth type="date" label="Grinding Date" name="grindingDate" value={formData.grindingDate} onChange={handleChange} sx={{ mb: 2 }} required />
          <TextField fullWidth label="Grinding Total Time (mins)" name="grindingTotalTime" value={formData.grindingTotalTime} onChange={handleChange} sx={{ mb: 2 }} required />
          <TextField fullWidth label="Powder Weight (g)" name="powderWeightG" value={formData.powderWeightG} onChange={handleChange} sx={{ mb: 2 }} required />
          <TextField fullWidth label="Powder Weight (lbs)" name="powderWeightLbs" value={formData.powderWeightLbs} onChange={handleChange} sx={{ mb: 2 }} required />
          <Button type="submit" variant="contained" fullWidth>Submit</Button>
        </form>
      </Paper>
    </Box>
  );
}

export default DehydrationForm;
